import { getToken } from '@/utils/auth'
import request from '@/utils/request'

export function sdSegTask(cb, close, err) {
    var urlps = 'type=pc&'
    urlps += 'access_token=' + getToken()
    const eventSource = new EventSource(
        process.env.BASE_API + '/user/ai/ai/aiChatMjLogs/chatStream?' + urlps
    )

    eventSource.addEventListener('message', event => {
        cb(JSON.parse(event.data))
    })
    eventSource.addEventListener('error', error => {
        close()
        eventSource.close()
        console.log(error)
    })
    eventSource.__close = () => {
        eventSource.__CLOSED = true
        eventSource.close()
    }
    return eventSource
}

export function selectSplit(data) {
    return request({
        url: '/user/ai/ai/aiChatMjLogs/selectSplit',
        method: 'post',
        data
    })
}




export function splitImage(data) {
    return request({
        url: '/user/ai/ai/aiChatMjLogs/splitImage',
        method: 'post',
        data
    })
}

export function segImage(data) {
    return request({
        url: '/user/user/user/userChatContent/segImage',
        method: 'post',
        data
    })
}


export function mattingImage(data) {
    return request({
        url: '/user/ai/ai/aiChatMjLogs/mattingImage',
        method: 'post',
        data
    })
}
export function getColorTypeList() {
    return request({
        url: '/user/user/user/userChatContent/getPromptTypeList',
        method: 'post'

    })
}

export function splitImageForPoint(data) {
    return request({
        url: '/user/ai/ai/aiChatMjLogs/getMaskOnly',
        method: 'post',
        data

    })
}







export function cancelQueue(data) {
    return request({
        url: '/user/user/user/userChatContent/cancelQueue',
        method: 'post',
        data
    })
}

export function getQueueLength(data) {
    return request({
        url: '/user/user/user/userChatContent/getQueueLength',
        method: 'post',
        data
    })
}













// WEBPACK FOOTER //
// ./src/api/ai/sdService.js